export default __webpack_public_path__ + "static/media/backers4.cdb3b3d3.png";